import { derived, writable } from 'svelte/store';

import { backend } from '$lib/services/backends';
import { user } from '$lib/services/user';
import { hasMouse, isLargeScreen, isLocalHost } from '$lib/services/user/env';

export const canShowMobileSignInDialog = derived(
  [isLargeScreen, hasMouse, isLocalHost, backend, user],
  ([_isLargeScreen, _hasMouse, _isLocalHost, _backend, _user]) =>
    _isLargeScreen && _hasMouse && !_isLocalHost && !!_backend?.isGit && !!_user?.token,
);

export const showMobileSignInDialog = writable(false);
